import { useState } from "react";
import { Comment } from "../../models/Comment";
import { ViewableDateLong } from "../../models/ViewableDate";
import "../../styles/comments/commentEditor.css";
import { Button } from "../buttons/Button";
import Icon from "../Icon";

export { CommentEditor };

type Props = {
  /**
   * Undefined means new comment is being added.
   */
  comment?: Comment;
  /**
   * If argument is an empty string, indicates comment being removed/discareded
   */
  onCommentEdit: (comment: string) => void;
};
const MAX_COMMENT_LENGTH = 2048;
/**
 * Component allows for comment to be edited and viewed. Only editable if no comment set
 * @param props
 * @returns
 */
const CommentEditor = (props: Props) => {
  const [comment, setComment] = useState(props.comment?.comment ?? "");
  // changed also means
  const [editable, setEditable] = useState(props.comment == undefined);

  const saved = props.comment && props.comment.created != undefined;

  return (
    <div className={"commentEditor"}>
      {saved && (
        <>
          <span className={"details"}>
            {ViewableDateLong(props.comment!.created)}
          </span>
          <span className={"details"}>{props.comment!.author}</span>
        </>
      )}
      {!saved && <span className={"details"}>Not yet saved</span>}
      {!editable && <pre>{comment}</pre>}
      {editable && (
        <>
          <textarea
            autoFocus
            tabIndex={10}
            value={comment}
            onChange={(e) => {
              setComment(e.target.value);
            }}
          />

          <div className={"buttons"}>
            <Button
              className={"padded"}
              tabIndex={12}
              onClick={() => props.onCommentEdit("")}
              name={"delete"}
            >
              Delete
              <Icon altText={"Delete"} icon={"trash"} />
            </Button>
            <Button
              className={"padded"}
              tabIndex={11}
              onClick={() => {
                setEditable(false);
                props.onCommentEdit(
                  comment.length > MAX_COMMENT_LENGTH
                    ? comment.substring(0, MAX_COMMENT_LENGTH - 1)
                    : comment,
                );
              }}
              disabled={comment.trim().length === 0}
              name={"confirm"}
            >
              Add
              <Icon altText={"Confirm Changes"} icon={"edit"} />
            </Button>
          </div>
        </>
      )}
    </div>
  );
};
